/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_Doesnt_ExistInputs */



/**
* | output |
* | --- |
* | "This page doesn't exist" |
*
* @param {Error_Notfound_Heading_Doesnt_ExistInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_doesnt_exist = /** @type {((inputs?: Error_Notfound_Heading_Doesnt_ExistInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_Doesnt_ExistInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Seite gibt es nicht")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette page n'existe pas")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这个页面不存在")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這個頁面不存在")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 페이지는 존재하지 않습니다")
	return /** @type {LocalizedString} */ ("This page doesn't exist")
});